<template>
  <div class="pin-bookmark-wrapper">
    <div>
      <div v-if="bookmarkData && bookmarkData.isPin" @click="handleTogglePin">
        <img
          class="unpin-icon"
          src="@/assets/image/homebase/bookmarks/pin-active.svg"
          alt="Unpin bookmark"
        />
      </div>
      <div
        v-else
        class="pin-btn pin-btn-wrapper"
        @mouseover="setDisplayMsg('Pin limit reached. Please unpin a bookmark and try again.')"
        @mouseleave="setDisplayMsg('')"
        @click="handleUnpin"
      >
        <img
          class="pin-icon"
          :class="{ 'pin-disabled': pinningDisabled }"
          src="@/assets/image/homebase/bookmarks/pin-inactive.svg"
          alt="Pin bookmark"
        />
      </div>
    </div>
    <div v-if="successMsg" class="success-popup">
      <div class="success-popup-card px-2 py-1">
        {{ successMsg }}
      </div>
    </div>
    <div v-if="displayMsg && displayMsg.length > 0" class="pin-disabled-popup">
      <div class="pin-disabled-popup-card px-2 py-1">
        {{ displayMsg }}
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "pin-bookmark",
  props: ["bookmarkData", "pinningDisabled", "successMsg"],
  mixins: [HomebaseMixpanelMixin],
  data() {
    return {
      displayMsg: "",
    };
  },
  methods: {
    handleUnpin() {
      if (this.pinningDisabled) return;
      this.handleTogglePin();
    },
    handleTogglePin() {
      let isPin = !this.bookmarkData.isPin;
      api
        .saveBookmark(
          this.bookmarkData.title,
          this.bookmarkData.url,
          this.bookmarkData.sourceType,
          this.bookmarkData.id,
          isPin
        )
        .then((response) => {

          let bookmarkData = response.data;
          let eventType = bookmarkData.isPin
            ? "bookmarkPinned"
            : "bookmarkUnpinned";
          this.$emit(eventType, bookmarkData);
          let trackingEvent = bookmarkData.isPin
            ? "pinned"
            : "unpinned";
          let subEvent = `${bookmarkData.title} - ${bookmarkData.url}`
          this.trackBookmarkPinUpdate(trackingEvent, subEvent)
        })
        .catch((err) => {
          // suppress
        });
    },
    setDisplayMsg(val) {
      if (!this.pinningDisabled) return;
      this.displayMsg = val;
    },
  },
};
</script>

<style scoped>
.pin-btn-wrapper {
  min-width: 22px;
  padding-left: 2px;
}
.pin-icon {
  margin-right: 5px;
}
.unpin-icon:hover,
.pin-icon:hover {
  cursor: pointer !important;
}
.pin-icon.pin-disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}
.pin-bookmark-wrapper {
  position: relative;
}
.success-popup,
.pin-disabled-popup {
  color: #666;
  font-family: artifaktElementBold !important;
  position: absolute;
  right: calc(100% + 12px);
  top: -4px;
  z-index: 14 !important;
}
.success-popup-card,
.pin-disabled-popup-card {
  background: white;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  border-radius: 4px;
}

.success-popup-card {
  color: #2BC275 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/bookmarks/PinBookmark.vue